import { useAuth } from 'react-oidc-context'

export function LoggedOut() {
  const auth = useAuth()

  function handleSignIn() {
    // prompt=login forces Cognito to show the login form even if a residual
    // SSO cookie exists — ensures the user actively re-authenticates.
    auth.signinRedirect({ extraQueryParams: { prompt: 'login' } })
  }

  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center">
      <div className="text-center space-y-4">
        <p className="text-fg-secondary font-sans text-sm">You have been signed out.</p>
        <button
          onClick={handleSignIn}
          className="px-4 py-2 rounded bg-solid hover:bg-solid-hover text-white font-sans text-sm transition-colors"
        >
          Sign in again
        </button>
      </div>
    </div>
  )
}
